import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { RockMilestone } from 'src/app/shared'

import { ListItem, RepositoryModal } from '../../../shared'
import { RocksComponent } from '.././rocks.component'

@Component({
    templateUrl: './rock-milestone.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class RockMilestoneComponent extends RepositoryModal<RockMilestone> implements OnInit {
    faQuestionCircle = faCircleQuestion
    userList: ListItem<string>[] = []
    rockId = ''

    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as RocksComponent
        this.userList = parentComponent.allActiveUserList.filter(listItem => parentComponent.meeting()?.userIds.includes(listItem.value))
        this.rockId = parentComponent.rockId()

        if (this.isAdding) {
            //this.target.userId = this.services.authentication.userId()
            this.userList.forEach(user => {
                if (user.value === this.services.authentication.userId()) {
                    user.$checked = true
                }
            })

            this.target.dueDate = new Date().addDays(7) // Default to 7 days from now
        }
    }

    protected onBeforeSave(): boolean {
        if (this.isAdding) {
            this.target.userIds = this.userList.filter(user => user.$checked).map(user => user.value)
            if (this.target.userIds.length === 0) {
                this.services.notification.warning('Please select at least one user to assign to the To-Do.')
                return false
            }

            // Send an empty Guid, since the userId is a required field, but not used when adding a new To-Do
            this.target.userId = this.services.utility.emptyGuid()

            this.target.rockId = this.rockId
        }

        return true
    }
}
